import React, { useState, useContext, useEffect } from "react";
import {
  FieldInput,
  ManageMapperLayout,
  SliderPanel,
  LoaderWrapper,
} from "../../../components";
import RACTile from "./RACTile";
import "./sample.css";
import { get, isEmpty } from "lodash";
import {
  MANAGE_MAPPER_ROUTES,
  ROUTES,
  getPathWithParam,
  FLOW_TYPES,
  stringToFunctionConverter,
  passthroughStringToFunctionConverter,
} from "../../../utils";
import {
  manageMapperStore,
  MANAGE_MAPPER_POST_API_ERROR,
  setManageMapperToastInfo,
} from "../../../contexts";
import { Form, Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { isNullOrUndefined } from "@microsoft/applicationinsights-core-js";
import {
  onUpdateStatus,
  cloneProfile,
  deleteMappingProfile,
  checkProfileNameExists,
  deleteOutputProfile,
  validateOutputProfile,
  cloneOutputProfile,
  outputSaveBasicInformation,
  getValidationRules,
} from "../../../services";
import { Field, Formik, isEmptyArray } from "formik";
import { useRouterParams } from "../../../abstracts";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DeleteWarningMapper from "../../../components/DeleteWarningMapper/DeleteWarningMapper";
import AddToolTip from "../../../components/AddToolTip";

export const getOutputTargetType = (sourceType) => {
  switch (sourceType) {
    case 1:
      return "File";
    case 2:
      return "API";
  }
};

export const getFileFormat = (format) => {
  switch (format) {
    case 1:
      return "CSV";
    case 2:
      return "Fixed Width";
    case 3:
      return "Excel";
  }
};

export const getDataModel = (dataModel) => {
  switch (dataModel) {
    case 1:
      return "Payroll";
    case 2:
      return "Census";
    case 3:
      return "Payroll and Census";
  }
};

const OverviewContainer = (props) => {
  const { flow, mapType } = useRouterParams();
  const { history } = props;
  const initialValues = {
    cloneProfileName: "",
  };
  const { state, dispatch } = useContext(manageMapperStore);
  const data = get(state, "api.data", {});
  const rulesetId = get(data, "ruleSetId", null);
  const fieldHeadersJson = get(data, "headerMapJson", []);
  const basicInformation = get(state, "basicInformation", []);
  const [isModalOpen, setModalOpen] = useState(false);
  const sourceLength =
    !isEmpty(fieldHeadersJson) && JSON.parse(fieldHeadersJson).length;
  const a = get(data, "objectMaps")?.map((_) => {
    if (!isEmpty(_.childObjectMaps)) {
      return _.childObjectMaps.length - 1;
    } else return 0;
  });
  const [dataLoading, setDataLoading] = useState(false);
  const childObjectMaps = a?.reduce((a, b) => a + b, 0);
  const objectLength =
    !isEmpty(data) &&
    (mapType == 1
      ? get(data, "objectMaps")?.length + childObjectMaps
      : mapType == 3
      ? get(data, "outputTemplateMaps")?.length
      : get(data, "mappingObjectMaps")?.length);
  const [isActive, setisActive] = useState();
  const format = get(data, "format");
  const fixedWidthOutputSectionFields = get(data, "fixedWidthOutputSections");
  let mappedFieldFixedWidthLength = 0;
  fixedWidthOutputSectionFields?.map((curr, i) => {
    return (mappedFieldFixedWidthLength +=
      curr?.fixedWidthOutputSectionFields?.length);
  });
  const profileId = get(state, "api.data.id");
  const [aggregateInfoString, setAggregateInfoString] = useState();
  const [dupStrategy, setDupStrategy] = useState();
  const [customLogics, setCustomLogics] = useState();
  const [keyFields, setKeyFields] = useState();
  const [isAggregation, setAggregation] = useState(false);
  const objectMaps = !isEmpty(data) && get(data, "objectMaps", []);
  const [countTransforms, setCountTransforms] = useState(0);
  const configJsonString = !isEmpty(data) && get(data, "configurationJson", []);
  const configJson = !isEmpty(configJsonString) && JSON.parse(configJsonString);
  const [showWarning, setShowWarning] = useState(false);
  const [isPopupOpen, setisPopupOpen] = useState(0);
  const [warning, setWarning] = useState([]);
  const [nameExists, setNameExists] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [rulesLength, setRulesLength] = useState();
  const DeleteToastMessage =
    "Your profile will be deleted. Do you wish to continue ? ";
  const DeleteToastMessageHead = "Are you sure? ";
  const filterjson = data.filterObjectJson && JSON.parse(data.filterObjectJson);
  const A =
    mapType == 1 ? filterjson?.filter((x) => x.selected == true) : filterjson;
  const profileName = !isEmpty(data) && get(data, "name");
  const numPlans =
    !isEmpty(data) &&
    (mapType == 1
      ? get(data, "planProfiles", 0)
      : get(data, "outputPlanProfiles", 0));
  const planGroupCount = get(data, "outputPlanGroupProfileMappings");
  let planGroupCountLength = 0;
  planGroupCount?.map((curr, i) => {
    return (planGroupCountLength += curr?.count);
  });
  const lengthTargetHeaderMapJson = data?.outputTemplateMaps?.filter(
    (_) =>
      !isEmptyArray(_.ValueTransformations) ||
      !isEmptyArray(_.HeaderTransformations)
  )?.length;
  const getTargetType = () => {
    switch (data.uploadedFileType) {
      case 1:
        return "DC-census";
      case 2:
        return "DC-payroll";
      case 3:
        return "DC-payroll & census";
      case 4:
        return "DC-loan";
    }
  };

  useEffect(() => {
    if (!isNullOrUndefined(rulesetId)) {
      setDataLoading(true);
      getValidationRules(rulesetId)
        .then((response) => {
          setRulesLength(response?.length);
          setDataLoading(false);
        })
        .catch((err) => {
          setDataLoading(false);
          dispatch({
            type: MANAGE_MAPPER_POST_API_ERROR,
            payload: "Something went wrong! please try again.",
          });
        });
    }
  }, [profileId]);

  useEffect(() => {
    if (!isEmpty(data)) {
      setisActive(get(data, "isActive"));
      if (data.isAggregationModel) {
        let c = 0;
        setAggregation(true);
        const aggregateInfo =
          !isEmpty(data) && get(data, "aggregationModelJson");
        setAggregateInfoString(aggregateInfo);
        const aggregateInfoJson = JSON.parse(aggregateInfo);
        setDupStrategy(aggregateInfoJson.aggregationStrategy);
        aggregateInfoJson.aggregationOperationEntities.map((item) => {
          if (!isEmpty(item.operation)) {
            c = c + 1;
          }
        });
        setCustomLogics(c);
        setKeyFields(aggregateInfoJson.aggregationEntites.length);
      } else {
        setAggregation(false);
      }

      let count = 0;
      objectMaps.map((item) => {
        if (!isEmpty(item.fieldOperations)) {
          count = count + 1;
        } else if (!isEmpty(item.childObjectMaps)) {
          count =
            count +
            item.childObjectMaps.filter((obj) => !isEmpty(obj.fieldOperations))
              .length;
        }
      });
      setCountTransforms(count);
    }
  }, [data]);
  const onSubmit = () => {
    setDataLoading(true);
    if (data?.mapType == 2) {
      outputSaveBasicInformation({
        ...data,
        isActive: isActive,
      })
        .then((res) => {
          setDataLoading(false);
          if (!isEmpty(res)) {
            history.push(`${ROUTES.MAPPER_HOME}`);
          }
        })
        .catch((error) => {
          setDataLoading(false);
        });
    } else {
      if (get(data, "isActive") !== isActive) {
        onUpdateStatus({ ...data, isActive: isActive })
          .then((res) => {
            setDataLoading(false);

            if (!isEmpty(res)) {
              history.push(`${ROUTES.MAPPER_HOME}`);
            }
          })
          .catch((err) => err, setDataLoading(false));
      }
      history.push(`${ROUTES.MAPPER_HOME}`);
    }
  };
  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      link: ROUTES.MAPPER_HOME,
    },
    {
      label: "Confirm",
      variant: "primary",
      type: "button",
      onClick: onSubmit,
    },
  ];
  const deleteEmployee = () => {
    setShowWarning(true);
  };
  const handleCancelClick = () => {
    setShowWarning(false);
  };

  const handleConfirmClick = () => {
    if (data?.mapType == 2) {
      deleteOutputProfile(profileId)
        .then((response) => {
          if (response) {
            history.push(`${ROUTES.MAPPER_HOME}`);
            dispatch(
              setManageMapperToastInfo({
                showToast: true,
                toastMessage: "Profile deleted successfully",
              })
            );
          }
        })
        .catch((error) => {
          dispatch({
            type: MANAGE_MAPPER_POST_API_ERROR,
            payload: "Something went wrong! please try again.",
          });
        });
    } else {
      deleteMappingProfile(profileId)
        .then((response) => {
          history.push(`${ROUTES.MAPPER_HOME}`);
          dispatch(
            setManageMapperToastInfo({
              showToast: true,
              toastMessage: "Profile deleted successfully",
            })
          );
        })
        .catch((error) => {});
    }
    setShowWarning(false);
  };

  const handleClose = () => {
    setWarning([]);
    setisPopupOpen(false);
  };
  return (
    <Formik initialValues={initialValues} enableReinitialize>
      {({ values, setFieldValue, setSubmitting, handleSubmit }) => {
        const onCloneProfile = (id, name) => {
          if (name.length > 150) {
            setErrorMsg("Map name should not exceed above 150 characters");
          } else if (name.length == 0) {
            setErrorMsg("Required : Profile Name");
          } else {
            if (data?.mapType == 2) {
              validateOutputProfile(name).then((response) => {
                setDataLoading(false);
                setNameExists(response);
                if (response) {
                  setErrorMsg("Map name already exists");
                } else if (
                  response &&
                  name !== get(state, "api.data.name", "")
                ) {
                  setErrorMsg("Map name already exists");
                } else if (!response) {
                  setSubmitting(true);
                  cloneOutputProfile(id, name)
                    .then(() => {
                      history.push(`${ROUTES.MAPPER_HOME}`);
                    })
                    .catch((err) => {
                      return err;
                    });
                }
              });
            } else {
              checkProfileNameExists(id, name).then((response) => {
                setDataLoading(false);
                setNameExists(response);
                if (response) {
                  setErrorMsg("Map name already exists");
                } else if (
                  response &&
                  name !== get(state, "api.data.name", "")
                ) {
                  setErrorMsg("Map name already exists");
                } else if (!response) {
                  setSubmitting(true);
                  cloneProfile(id, name)
                    .then(() => {
                      history.push(`${ROUTES.MAPPER_HOME}`);
                    })
                    .catch((err) => {
                      return err;
                    });
                }
              });
            }
          }
        };

        const handleAcceptWarning = () => {
          setWarning([]);
          values.acceptWarning = true;
          setisPopupOpen(false);
        };
        return (
          <LoaderWrapper isLoading={dataLoading}>
            <ManageMapperLayout buttons={buttons} layoutHeader={"Overview"}>
              <div className="d-flex justify-content-space-between">
                <div className="d-flex-row">
                  <div className="mr-5">
                    <div style={{ fontSize: "14px" }}>Profile name</div>

                    <AddToolTip name={profileName}>
                      <div
                        className="font-weight-bold text-overflow-elipsis"
                        style={{ fontSize: "18px", width: "300px" }}
                      >
                        {profileName}
                      </div>
                    </AddToolTip>
                  </div>
                  <div className="mx-5">
                    <div style={{ fontSize: "14px" }}>Status</div>
                    <div className="d-flex">
                      <Form.Check
                        type="switch"
                        id={`custom-switch-1`}
                        label=" "
                        checked={isActive}
                        style={{ height: "22px", width: "44px" }}
                        onChange={() => {
                          setisActive(!isActive);
                        }}
                      />
                      <div
                        style={{
                          fontSize: "14px",
                          width: "50px",
                          overflow: "visible",
                        }}
                        className="ml-3"
                      >
                        {isActive ? "Active" : "InActive"}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex-row">
                  <OverlayTrigger overlay={<Tooltip>Clone</Tooltip>}>
                    <div className="mr-5 mt-2">
                      <i
                        style={{
                          height: "18px",
                          cursor: "pointer",
                        }}
                        className="far fa-copy cloneHoverTransition color-primary-var"
                        onClick={() => setModalOpen(true)}
                      ></i>
                      <p style={{ fontSize: "15px" }}>Clone</p>
                    </div>
                  </OverlayTrigger>
                  <OverlayTrigger overlay={<Tooltip>Delete</Tooltip>}>
                    <div className="mr-3 mt-2 pointer">
                      <FontAwesomeIcon
                        icon={faTrashAlt}
                        color="#EB5757"
                        className="payroll-delete"
                        onClick={deleteEmployee}
                      />
                      <p style={{ fontSize: "15px" }}>Delete</p>
                    </div>
                  </OverlayTrigger>
                </div>
              </div>

              <SliderPanel
                isOpen={isModalOpen}
                size="30"
                showCancel={false}
                backdropClicked={false}
              >
                <div className="d-flex justify-content-between align-baseline">
                  <div>
                    <p className="investment-heading">Clone Profile</p>
                  </div>
                  <div>
                    <Button
                      variant="secondary"
                      onClick={() => {
                        setModalOpen(false);
                        setFieldValue("cloneProfileName", "");
                        setErrorMsg("");
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="primary"
                      className="ml-4"
                      onClick={() => {
                        onCloneProfile(profileId, values["cloneProfileName"]);
                      }}
                    >
                      Confirm
                    </Button>
                  </div>
                </div>

                <Field
                  name={"cloneProfileName"}
                  label={"Profile Name"}
                  component={FieldInput}
                  noLabelTransform
                  isRequired
                />

                <div
                  style={{
                    fontSize: "0.75rem",
                    marginTop: "-0.75rem",
                    paddingTop: "0rem",
                    color: "#ff5050",
                  }}
                >
                  {errorMsg}
                </div>
              </SliderPanel>

              <hr className="mt-4" style={{ color: "inherit" }} />
              <div
                style={{ marginTop: "3.125rem", overflow: "scroll" }}
                className="mapper-raccontainer-grid mb-5"
              >
                {data.mapType == 1 || data.mapType == 3 ? (
                  <RACTile
                    profileId={profileId}
                    tileRoute={getPathWithParam({
                      path: MANAGE_MAPPER_ROUTES.SOURCE,
                      pathParam: [flow, mapType, profileId],
                    })}
                    title="Source"
                    height="9.188rem"
                  >
                    <div style={{ fontSize: "12px", color: "grey" }}>
                      Source Name
                    </div>

                    <AddToolTip name={data.name}>
                      <div
                        className="text-overflow-elipsis"
                        style={{ fontSize: "14px", width: "220px" }}
                      >
                        {data.name}
                      </div>
                    </AddToolTip>

                    {mapType == 3 ? (
                      <>
                        <div style={{ fontSize: "12px", color: "grey" }}>
                          Source Format
                        </div>
                        <div style={{ fontSize: "14px" }}>
                          {getFileFormat(data?.format)}
                        </div>
                      </>
                    ) : (
                      <>
                        <div style={{ fontSize: "12px", color: "grey" }}>
                          Source Type
                        </div>
                        <div style={{ fontSize: "14px" }}>File</div>
                      </>
                    )}

                    {data?.format == 1 && (
                      <>
                        <div style={{ fontSize: "12px", color: "grey" }}>
                          Delimiter
                        </div>
                        <div style={{ fontSize: "14px" }}>
                          {configJson?.delimiter}
                        </div>
                      </>
                    )}
                    {data?.format == 2 && (
                      <>
                        <div style={{ fontSize: "12px", color: "grey" }}>
                          Record Length
                        </div>
                        <div style={{ fontSize: "14px" }}>
                          {configJson?.recordLength}
                        </div>
                      </>
                    )}
                    {data?.format != 2 && (
                      <>
                        <div style={{ fontSize: "12px", color: "grey" }}>
                          Has Header
                        </div>
                        <div style={{ fontSize: "14px" }}>
                          {configJson?.hasHeader ? "Yes" : "No"}
                        </div>
                      </>
                    )}
                    {mapType == 1 ? (
                      <AddToolTip name={data.fileName}>
                        <div
                          className="text-overflow-elipsis"
                          style={{ width: "220px" }}
                        >
                          {data.fileName}
                        </div>
                      </AddToolTip>
                    ) : null}
                  </RACTile>
                ) : null}

                {mapType == 3 && (
                  <RACTile
                    profileId={profileId}
                    tileRoute={getPathWithParam({
                      path: MANAGE_MAPPER_ROUTES.PASSTHROUGH_TARGET,
                      pathParam: [flow, mapType, profileId],
                    })}
                    title="Target"
                    height="9.188rem"
                    mapType={mapType}
                  >
                    <div style={{ fontSize: "12px", color: "grey" }}>
                      Target Name
                    </div>
                    <AddToolTip name={data.name}>
                      <div
                        className="text-overflow-elipsis"
                        style={{ fontSize: "14px", width: "220px" }}
                      >
                        {data.targetFileName}
                      </div>
                    </AddToolTip>
                    <div style={{ fontSize: "12px", color: "grey" }}>
                      Target Type
                    </div>
                    <div style={{ fontSize: "14px" }}>
                      {data.isCOREDCProfile ? "Core" : "File"}
                    </div>
                    <div style={{ fontSize: "12px", color: "grey" }}>
                      Has Header
                    </div>
                    <div style={{ fontSize: "14px" }}>
                      {data?.hasHeader ? "Yes" : "No"}
                    </div>
                    {data.isCOREDCProfile ? (
                      <>
                        <div style={{ fontSize: "12px", color: "grey" }}>
                          FTP URL
                        </div>
                        <div style={{ fontSize: "14px" }}>
                          {data?.redirectFTP?.sftpHost == null
                            ? "-"
                            : data?.redirectFTP?.sftpHost}
                        </div>
                        <div style={{ fontSize: "12px", color: "grey" }}>
                          FTP Path
                        </div>
                        <div style={{ fontSize: "14px" }}>
                          {data?.redirectFTP?.sftpPath == null
                            ? "-"
                            : data?.redirectFTP?.sftpPath}
                        </div>
                      </>
                    ) : null}
                  </RACTile>
                )}

                {mapType == 2 && (
                  <RACTile
                    profileId={profileId}
                    tileRoute={getPathWithParam({
                      path: MANAGE_MAPPER_ROUTES.OUTPUT_TARGET,
                      pathParam: [flow, mapType, profileId],
                    })}
                    title="Target"
                    height="9.188rem"
                    mapType={mapType}
                  >
                    <div style={{ fontSize: "12px", color: "grey" }}>
                      File Name
                    </div>

                    <AddToolTip name={data.name}>
                      <div
                        className="text-overflow-elipsis"
                        style={{ fontSize: "14px", width: "220px" }}
                      >
                        {data.name}
                      </div>
                    </AddToolTip>
                    <div style={{ fontSize: "12px", color: "grey" }}>
                      File format
                    </div>
                    <div style={{ fontSize: "14px" }}>
                      {getFileFormat(data?.format)}
                    </div>
                    {data?.format == 1 && (
                      <>
                        <div style={{ fontSize: "12px", color: "grey" }}>
                          Delimiter
                        </div>
                        <div style={{ fontSize: "14px" }}>
                          {data?.delimiter}
                        </div>
                      </>
                    )}
                    {data?.format == 2 && (
                      <>
                        <div style={{ fontSize: "12px", color: "grey" }}>
                          Record Length
                        </div>
                        <div style={{ fontSize: "14px" }}>
                          {data?.recordLength}
                        </div>
                      </>
                    )}
                    {data?.format != 2 && (
                      <>
                        <div style={{ fontSize: "12px", color: "grey" }}>
                          Has Header
                        </div>
                        <div style={{ fontSize: "14px" }}>
                          {data?.hasHeader ? "Yes" : "No"}
                        </div>
                      </>
                    )}
                    <div style={{ fontSize: "12px", color: "grey" }}>
                      Has Encryption
                    </div>
                    <div style={{ fontSize: "14px" }}>
                      {data?.hasEncryption ? "Yes" : "No"}
                    </div>
                  </RACTile>
                )}

                {mapType == 1 || mapType == 2 ? (
                  <RACTile
                    profileId={profileId}
                    tileRoute={getPathWithParam({
                      path: MANAGE_MAPPER_ROUTES.BASIC_INFORMATION,
                      pathParam: [flow, mapType, profileId],
                    })}
                    title="Plan association"
                  >
                    <div style={{ fontSize: "12px", color: "grey" }}>
                      Number of plans associated
                    </div>
                    <div style={{ fontSize: "14px", marginBottom: "1.063rem" }}>
                      {numPlans?.length + planGroupCountLength}
                    </div>
                  </RACTile>
                ) : null}

                {mapType == 1 &&
                  (isAggregation ? (
                    <RACTile
                      profileId={profileId}
                      tileRoute={getPathWithParam({
                        path: MANAGE_MAPPER_ROUTES.AGGREGATE,
                        pathParam: [flow, mapType, profileId],
                      })}
                      title="Manage duplicates"
                    >
                      <div>
                        <div style={{ fontSize: "12px", color: "grey" }}>
                          Duplication Strategy used
                        </div>
                        <div style={{ fontSize: "14px" }}>{dupStrategy}</div>
                        <div style={{ fontSize: "12px", color: "grey" }}>
                          Number of fields with custom logics applied
                        </div>
                        <div style={{ fontSize: "14px" }}>{customLogics}</div>
                        <div style={{ fontSize: "12px", color: "grey" }}>
                          Number of key fields used
                        </div>
                        <div style={{ fontSize: "14px" }}>{keyFields}</div>
                      </div>
                    </RACTile>
                  ) : (
                    <RACTile
                      profileId={profileId}
                      tileRoute={getPathWithParam({
                        path: MANAGE_MAPPER_ROUTES.AGGREGATE,
                        pathParam: [flow, mapType, profileId],
                      })}
                      title="Manage duplicates"
                    >
                      <div>
                        <div style={{ fontSize: "12px", color: "grey" }}>
                          Duplication Strategy used
                        </div>
                        <div style={{ fontSize: "14px" }}>-</div>
                        <div style={{ fontSize: "12px", color: "grey" }}>
                          Number of fields with custom logics applied
                        </div>
                        <div style={{ fontSize: "14px" }}>-</div>
                        <div style={{ fontSize: "12px", color: "grey" }}>
                          Number of key fields used
                        </div>
                        <div style={{ fontSize: "14px" }}>-</div>
                      </div>
                    </RACTile>
                  ))}

                {mapType == 1 && (
                  <RACTile
                    profileId={profileId}
                    tileRoute={getPathWithParam({
                      path: MANAGE_MAPPER_ROUTES.TARGET,
                      pathParam: [flow, mapType, profileId],
                    })}
                    title="Target"
                  >
                    <div style={{ fontSize: "12px", color: "grey" }}>
                      Target Type
                    </div>
                    <div style={{ fontSize: "14px" }}>
                      {data.isCOREDCProfile ? "Core" : "File"}
                    </div>
                    {data.isCOREDCProfile ? (
                      <>
                        <div style={{ fontSize: "12px", color: "grey" }}>
                          File Type
                        </div>
                        <div style={{ fontSize: "14px" }}>
                          {getTargetType()}
                        </div>
                      </>
                    ) : null}
                    {!data.isCOREDCProfile ? (
                      <>
                        <div style={{ fontSize: "12px", color: "grey" }}>
                          FTP URL
                        </div>
                        <div style={{ fontSize: "14px" }}>-</div>
                        <div style={{ fontSize: "12px", color: "grey" }}>
                          FTP Path
                        </div>
                        <div style={{ fontSize: "14px" }}>-</div>
                      </>
                    ) : null}
                  </RACTile>
                )}

                {mapType == 2 && (
                  <RACTile
                    profileId={profileId}
                    tileRoute={getPathWithParam({
                      path: MANAGE_MAPPER_ROUTES.OUTPUT_TARGET,
                      pathParam: [flow, mapType, profileId],
                    })}
                    title="FTPDetails"
                  >
                    <div style={{ fontSize: "12px", color: "grey" }}>
                      Target Type
                    </div>
                    <div style={{ fontSize: "14px" }}>
                      {getOutputTargetType(data?.sourceType)}
                    </div>
                    <div style={{ fontSize: "12px", color: "grey" }}>
                      FTP URL
                    </div>
                    <div style={{ fontSize: "14px" }}>
                      {<AddToolTip name={data?.ftpChannel?.url} /> ?? "-"}
                    </div>
                    <div style={{ fontSize: "12px", color: "grey" }}>
                      FTP Path
                    </div>
                    <div style={{ fontSize: "14px" }}>
                      {<AddToolTip name={data?.ftpChannel?.filePath} /> ?? "-"}
                    </div>
                  </RACTile>
                )}

                <RACTile
                  profileId={profileId}
                  tileRoute={getPathWithParam({
                    path:
                      mapType == 1 || mapType == 3
                        ? MANAGE_MAPPER_ROUTES.MAP_AND_TRANSFORM
                        : MANAGE_MAPPER_ROUTES.MAP_AND_TRANSFORM_OUTPUT,
                    pathParam: [flow, mapType, profileId],
                  })}
                  title="Map & Transform"
                >
                  <div
                    style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}
                  >
                    {mapType == 1 || mapType == 3 ? (
                      <div>
                        <div style={{ fontSize: "14px" }}>Source Fields</div>
                        <div
                          style={{
                            fontSize: "24px",
                            color: "orange",
                            marginBottom: "1.063rem",
                          }}
                        >
                          {sourceLength}
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div style={{ fontSize: "14px" }}>Data Model</div>
                        <div
                          style={{
                            fontSize: "16px",
                            color: "orange",
                            marginBottom: "1.063rem",
                          }}
                        >
                          {getDataModel(data?.dataModel)}
                        </div>
                      </div>
                    )}
                    <div>
                      <div style={{ fontSize: "14px" }}>Mapped Fields</div>
                      {format != 2 ? (
                        <div style={{ fontSize: "24px", color: "green" }}>
                          {objectLength}
                        </div>
                      ) : (
                        <div style={{ fontSize: "24px", color: "green" }}>
                          {mappedFieldFixedWidthLength}
                        </div>
                      )}
                    </div>
                    {mapType != 2 && (
                      <div>
                        <div style={{ fontSize: "14px" }}>Transformed</div>
                        <div style={{ fontSize: "24px", color: "purple" }}>
                          {mapType == 3
                            ? lengthTargetHeaderMapJson
                            : countTransforms}
                        </div>
                      </div>
                    )}
                  </div>
                </RACTile>

                {mapType == 3 ? (
                  <RACTile
                    profileId={profileId}
                    tileRoute={getPathWithParam({
                      path: MANAGE_MAPPER_ROUTES.VALIDATIONS,
                      pathParam: [flow, mapType, profileId],
                    })}
                    title="Validations"
                  >
                    <div style={{ fontSize: "12px", color: "grey" }}>
                      Number of Rules Configured
                    </div>
                    <div style={{ fontSize: "14px", marginBottom: "1.063rem" }}>
                      {rulesLength == null ? 0 : rulesLength}
                    </div>
                  </RACTile>
                ) : null}

                <RACTile
                  profileId={profileId}
                  tileRoute={getPathWithParam({
                    path:
                      mapType == 1
                        ? MANAGE_MAPPER_ROUTES.FILTER
                        : MANAGE_MAPPER_ROUTES.OUTPUT_FILTER,
                    pathParam: [flow, mapType, profileId],
                  })}
                  title="Filter"
                >
                  <div style={{ fontSize: "12px", color: "grey" }}>
                    Number of Filter conditions used
                  </div>
                  <div style={{ fontSize: "14px", marginBottom: "1.063rem" }}>
                    {A?.length ?? 0}
                  </div>
                </RACTile>

                {mapType == 1 && (
                  <>
                    <RACTile
                      profileId={profileId}
                      tileRoute={getPathWithParam({
                        path: MANAGE_MAPPER_ROUTES.RULESET,
                        pathParam: [flow, mapType, profileId],
                      })}
                      title="Ruleset"
                    >
                      <div style={{ fontSize: "12px", color: "grey" }}>
                        Ruleset Name
                      </div>
                      <div
                        style={{ fontSize: "14px", marginBottom: "1.063rem" }}
                      >
                        -
                      </div>
                      <div style={{ fontSize: "12px", color: "grey" }}>
                        Number of Rules Configured
                      </div>
                      <div style={{ fontSize: "14px" }}>-</div>
                    </RACTile>

                    <RACTile
                      profileId={profileId}
                      tileRoute={getPathWithParam({
                        path: MANAGE_MAPPER_ROUTES.SCHEDULER,
                        pathParam: [flow, mapType, profileId],
                      })}
                      title="Schedule"
                    >
                      <div style={{ fontSize: "12px", color: "grey" }}>
                        Import via
                      </div>
                      <div
                        style={{ fontSize: "14px", marginBottom: "1.063rem" }}
                      >
                        FTP-
                      </div>
                      <div style={{ fontSize: "12px", color: "grey" }}>
                        Frequency
                      </div>
                      <div style={{ fontSize: "14px" }}>-</div>
                    </RACTile>
                  </>
                )}
              </div>
            </ManageMapperLayout>
            <DeleteWarningMapper
              DeleteToastMessageHead={DeleteToastMessageHead}
              DeleteToastMessage={DeleteToastMessage}
              showModal={showWarning}
              handleConfirmClick={handleConfirmClick}
              handleCancelClick={handleCancelClick}
            />
          </LoaderWrapper>
        );
      }}
    </Formik>
  );
};

export default OverviewContainer;
